import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=4353fb79&"
import script from "./profile.ts?vue&type=script&lang=js&"
export * from "./profile.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports